"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _serializr = require("serializr");
var _root_model = _interopRequireDefault(require("./root_model"));
var _user_basic = _interopRequireDefault(require("./user_basic"));
var _membership = _interopRequireDefault(require("./membership"));
var _utils = require("@seedlang/utils");
var _serializer_helpers = require("./utils/serializer_helpers");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var PaymentMigration = (_dec = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec2 = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec3 = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec4 = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec5 = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec6 = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec7 = (0, _serializr.serializable)((0, _serializr.object)(_user_basic["default"])), _dec8 = (0, _serializr.serializable)((0, _serializr.object)(_membership["default"])), _class = /*#__PURE__*/function (_RootModel) {
  function PaymentMigration() {
    var _this;
    _classCallCheck(this, PaymentMigration);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PaymentMigration, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "paymentFailure", _descriptor2, _this);
    _initializerDefineProperty(_this, "patreonPledgeCadence", _descriptor3, _this);
    _initializerDefineProperty(_this, "status", _descriptor4, _this);
    _initializerDefineProperty(_this, "stripeSubscriptionId", _descriptor5, _this);
    _initializerDefineProperty(_this, "siteId", _descriptor6, _this);
    _initializerDefineProperty(_this, "currency", _descriptor7, _this);
    _initializerDefineProperty(_this, "stripeStatus", _descriptor8, _this);
    _initializerDefineProperty(_this, "completedAt", _descriptor9, _this);
    _initializerDefineProperty(_this, "paymentMethodAddedAt", _descriptor0, _this);
    _initializerDefineProperty(_this, "createdAt", _descriptor1, _this);
    _initializerDefineProperty(_this, "updatedAt", _descriptor10, _this);
    _initializerDefineProperty(_this, "nextChargeDate", _descriptor11, _this);
    _initializerDefineProperty(_this, "lastSyncedWithStripeAt", _descriptor12, _this);
    _initializerDefineProperty(_this, "user", _descriptor13, _this);
    _initializerDefineProperty(_this, "membership", _descriptor14, _this);
    return _this;
  }
  _inherits(PaymentMigration, _RootModel);
  return _createClass(PaymentMigration, [{
    key: "isUnstarted",
    get: function get() {
      return this.status === 'setting_up' || this.status === 'stripe_payment_setup_started' || (0, _utils.isBlank)(this.status);
    }
  }, {
    key: "isInProgress",
    get: function get() {
      return !this.isUnstarted && !this.isComplete;
    }
  }, {
    key: "isComplete",
    get: function get() {
      return this.status === 'completed';
    }
  }, {
    key: "friendlyStatus",
    get: function get() {
      if ((0, _utils.isBlank)(this.status)) {
        return;
      }
      return this.status.replaceAll('_', ' ');
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "paymentFailure", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "patreonPledgeCadence", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "status", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "stripeSubscriptionId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "siteId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "currency", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "stripeStatus", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "completedAt", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "paymentMethodAddedAt", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "nextChargeDate", [_mobx.observable, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "lastSyncedWithStripeAt", [_mobx.observable, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.observable, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "membership", [_mobx.observable, _dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
var _default = exports["default"] = PaymentMigration;